import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface FormGroupLabelProps {
  htmlFor?: string;
  children: React.ReactNode;
  required?: boolean;
}

const LabelComponent: React.FC<FormGroupLabelProps> = ({
  htmlFor,
  children,
  required,
}) => {
  return (
    <label htmlFor={htmlFor} className="peptalk-form-group-label">
      {children}
      {required && <span className="peptalk-required-indicator"> *</span>}
    </label>
  );
};

export const Label: React.FC<FormGroupLabelProps> = (
  props: FormGroupLabelProps
) => {
  const Component = useCustomComponent({
    componentName: 'FormGroupLabel',
    Component: LabelComponent,
  });

  return <Component {...props} />;
};
